import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import ImageCropper from './components/ImageCropper';
import ImageIcon from '@mui/icons-material/Image';
import { styled } from '@mui/system';

const Input = styled('input')({
  display: 'none',
});

interface EmblemUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onCropComplete: (croppedImage: File) => void;
}

const EmblemUploadDialog: React.FC<EmblemUploadDialogProps> = ({
  open,
  onClose,
  onCropComplete,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [uploadError, setUploadError] = useState<string | null>(null);

  // Lidar com escolha do arquivo
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          setSelectedImage(reader.result as string);
          setUploadError(null);
        }
      };
      reader.onerror = (err) => {
        console.error('Erro ao ler arquivo:', err);
        setUploadError('Falha ao ler o arquivo.');
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCancelCrop = () => {
    setSelectedImage(null);
    setUploadError(null);
  };

  const handleCropCompleteInternal = async (croppedFile: File) => {
    try {
      onCropComplete(croppedFile);
      handleCancelCrop();
      onClose();
    } catch (err) {
      console.error('Erro no corte do brasão:', err);
      setUploadError('Falha ao processar o brasão. Tente novamente.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Upload do Brasão</DialogTitle>
      <DialogContent>
        {!selectedImage ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 2,
            }}
          >
            <label htmlFor="upload-brasao-button">
              <Input
                accept="image/*"
                id="upload-brasao-button"
                type="file"
                onChange={handleFileChange}
              />
              <Button variant="contained" component="span" startIcon={<ImageIcon />}>
                Selecionar Imagem
              </Button>
            </label>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Escolha uma imagem para representar o brasão.
            </Typography>
            {uploadError && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {uploadError}
              </Typography>
            )}
          </Box>
        ) : (
          <ImageCropper
            imageSrc={selectedImage}
            onCropComplete={handleCropCompleteInternal}
            onCancel={handleCancelCrop}
          />
        )}
      </DialogContent>
      <DialogActions>
        {!selectedImage && <Button onClick={onClose}>Cancelar</Button>}
        {selectedImage && <Button onClick={handleCancelCrop}>Cancelar</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default EmblemUploadDialog;
